import { useSettings } from "../context/SettingsContext";

export const LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_meet-connect-capture/artifacts/0n1i4uby_7FBEA3C2-CC69-40C0-869A-F28DF2B0403D.webp";

const CUSTOM_LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/branding/logo`;

const useLogoSrc = () => {
  const ctx = useSettings();
  return ctx?.settings?.has_custom_logo ? CUSTOM_LOGO_URL : LOGO_URL;
};

export const Logo = ({ className = "h-10" }) => {
  const src = useLogoSrc();
  return <img src={src} alt="Stranger Sessions" className={`${className} w-auto object-contain`} data-testid="brand-logo" />;
};

export const LogoIcon = ({ className = "h-10" }) => {
  const src = useLogoSrc();
  return (
    <div className={`overflow-hidden relative rounded-md aspect-[9/20] ${className}`} data-testid="brand-logo-icon">
      <img
        src={src}
        alt="Stranger Sessions"
        className="absolute left-0 top-0 h-full w-auto"
        style={{ maxWidth: "none" }}
      />
    </div>
  );
};
